import { useState } from 'react';
import { FILTER_KEY_PREFIX, NEW_SOURCE } from '../content/whatsNew';

/** The newest source's filter button glows on a page until it is clicked once (remembered per page). */
export function useNewSourceFilter(pagePath: string) {
  const key = FILTER_KEY_PREFIX + pagePath.replace(/\//g, '');
  const [clicked, setClicked] = useState(() => !!localStorage.getItem(key));

  const glows = (source: string) => source === NEW_SOURCE && !clicked;
  const onSourceClick = (source: string) => {
    if (source !== NEW_SOURCE || clicked) return;
    localStorage.setItem(key, '1');
    setClicked(true);
  };

  return { glows, onSourceClick };
}
